export const FOUNDER_PROFILE_TYPE = 'Business Owner (Founder)' as const;
export const FOUNDER_PRODUCT_CODE = 'FOUNDERS ONCE OFF 01' as const;
export const FOUNDER_PLAN_ALLOWED_APPS = ['interview-genie', 'money-manager', 'speak-easy', 'biz-connect'] as const;
export const FOUNDER_BADGE_LABEL = 'Founder Trust Badge' as const;

export const isFounderProfileType = (value: unknown): boolean =>
  String(value || '').trim().toLowerCase() === FOUNDER_PROFILE_TYPE.toLowerCase();

export const isFounderProductCode = (value: unknown): boolean =>
  String(value || '').trim() === FOUNDER_PRODUCT_CODE;